import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    userInfo: {
      access_token: "",
    },
  },
  mutations: {
    set_store_token(state, data) {
      state.userInfo = data;
    },
  },
  actions: {
    set_store_token(context, data) {
      context.commit("set_store_token", data);
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: "store_data",
    }),
  ],
});
